<template>
    <div class="weight-setting">
        <div class="level">
            <div class="level-left">
                <h2 class="title is-size-4 level-item">{{ axis.name }}</h2>
            </div>
            <div class="level-right">
                <button v-if="!isEditing" class="button is-primary is-outlined level-item" @click="edit()">
                    Edit
                </button>
                <button v-if="isEditing" class="button is-primary is-outlined" @click="cancelEdit()">
                Cancel
                </button>
                <button v-if="isEditing" class="button is-primary is-outlined" @click="save">
                    Save
                </button>
            </div>
        </div>
        <b-notification type="is-warning" :closable="false" v-if="isTotalPercentageInvalid()">
            <i class="fas fa-exclamation-circle"></i>
            Weights should add to 100%, current total is {{ totalWeightPercentage }}%
        </b-notification>

        <b-table :data="axis.metrics"
            :default-sort-direction="'asc'"
            :striped="true"
            :loading="isLoading"
        >
            <template slot-scope="props">
                <b-table-column field="tool" label="Tool" sortable>
                    {{ props.row.tool }}
                </b-table-column>
                <b-table-column field="platform" label="Platform" sortable>
                    {{ props.row.platform }}
                </b-table-column>
                <b-table-column field="metric" label="Metric" sortable>
                    {{ props.row.metric }}
                </b-table-column>
                <b-table-column field="weight" label="Weight %" width="100" sortable centered>
                    <span v-if="!isEditing">{{ props.row.weight }}</span>
                    <!-- The 'validity.valid' property will be true if and only if the input falls within the range of 0(min) to 100(max).
                         If the input value is invalid or undefined then set the value to 0.
                     -->
                    <input type="number" min="0" max="100" oninput="(validity.valid && this.value) || (value = 0)" v-if="isEditing"
                    v-model.number="props.row.weight" class="input" :class="isTotalPercentageInvalid() ? 'is-danger' : ''" />
                </b-table-column>
            </template>
            <template slot="footer">
                <div class="has-text-right">
                    Total: {{ totalWeightPercentage }} %
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'WeightSetting',
    props: {
        axisWeights: {
            type: Object,
            required: false
        }
    },
    data () {
        return {
            axis: {},
            isLoading: true,
            errorMessage: '',
            isEditing: false,
            editCache: null
        };
    },
    created () {
        this.axis = Object.assign(this.axis, this.axisWeights);
        this.isLoading = false;
    },
    methods: {
        edit () {
            // save existing state so changes can be undone
            this.editCache = Object.assign({}, this.axis);
            this.isEditing = true;
        },
        cancelEdit () {
            this.axis = Object.assign({}, this.editCache);
            this.editCache = null;
            this.isEditing = false;
        },

        save () {
            this.isEditing = false;
            this.$emit('save-event', this.axis);
        },
        isTotalPercentageInvalid () {
            return this.totalWeightPercentage !== 100;
        }

    },
    computed: {
        totalWeightPercentage () {
            // Ignore undefined when summing
            return _.sumBy(this.axis.metrics, m => m.weight || 0);
        }
    }
};
</script>

<style lang="scss" scoped>
.weight-setting{
    max-width:1080px;
    margin:auto;

    .table td {
        vertical-align: middle;
    }

    h2 {
        margin: 0.5rem;
    }

    .button {
        margin: 0.5rem;
    }
}
</style>
